<template>
  <div>
    <NBar title="申诉反馈" :top="true"/>
    <nut-noticebar :scrollable="false" background="#cee0ff" color="#525975">
      <span>开启后，相应的场地开放申诉反馈入口功能。</span>
      <span class="check-btn" @click="show = true">查看样例 ></span>
    </nut-noticebar>
    <nut-cell :show-icon="false" class="diy-cell" style="background-size: 100% 0;" @click-cell="goWeChatSet()">
      <div slot="title">
        <span>默认</span>
        <span class="text">设置后新场地自动配置</span>
      </div>
      <span slot="desc">
        <nut-switch :active="true" class="my-switch"></nut-switch>
      </span>
    </nut-cell>
    <nut-infiniteloading @loadmore="onInfinite" :is-show-mod="true" :has-more="isHasMore" :is-loading="isLoading"
                         :threshold="200" style="margin-top: 10px">
      <nut-cell v-for="(item,index) in list" :key="index" :show-icon="false" class="diy-cell">
        <span slot="title">{{item.name}}</span>
        <span slot="desc">
          <nut-switch :active="true" class="my-switch"></nut-switch>
        </span>
      </nut-cell>
    </nut-infiniteloading>
    <nut-popup :style="{ padding: '30px 50px' }" v-model="show" closeable close-icon="cross">
      <p class="top-title">申诉反馈会出现在顾客扫码启动页</p>
      <img class="qrCode" :src="require('@/resource/img/device/complaint.png')">
    </nut-popup>
  </div>
</template>

<script>
export default {
  name: 'ComplainFeedback',
  data () {
    return {
      list: [{
        name: '广州增城恒大酒店'
      }, {
        name: '星港同创汇天璇座',
      }, {
        name: '风暴健身',
      }, {
        name: '小羊羔工作室女人花',
      }, {
        name: '女人花',
      }, {
        name: '丽聪美容',
      }, {
        name: '恒力博纳广场',
      }],
      page: 2,
      num: 5,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      show : false,
    }
  },
  methods: {
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        if (this.page <= 5) {
          let list = [{
            name: '常山美姸堂',
          }, {
            name: '弘丽香源美容SPA',
          }, {
            name: '河南悦容美容',
          }]
          for (let i in list) {
            this.list.push(list[i])
          }
          this.page = this.page + 1
        } else {
          this.isHasMore = false
        }
        this.isLoading = false
      }, 100)
    }
  }
}
</script>

<style scoped>
  .check-btn {
    color: #3c7be7;
  }

  .diy-cell {
    margin: 0px 15px;
    border-radius: 5px;
  }

  .diy-cell .text {
    color: #999;
    font-size: 12px;
    margin-left: 5px;
  }
  .top-title{
    text-align: center;
    font-size: 16px;
  }

  .qrCode{
    width: 240px;
    height: auto;
  }
  /deep/ .my-switch.nut-switch {
    border-color: #ccc;
    background-color: #ccc
  }

  /deep/ .my-switch.nut-switch .nut-switch-btn {
    border: 2px solid #fff;
    box-shadow: none;
    background-color: #fff;
  }

  /deep/ .my-switch.nut-switch.nut-switch-active {
    border-color: #1989fa;
    background-color: #1989fa;
  }

  /deep/ .my-switch.nut-switch.nut-switch-active .nut-switch-btn {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/ComplainFeedback.vue